/**
 * Envoi au serveur des notes en attente, dans l'ordre de création.
 * Sur iPhone, Safari ne synchronise pas en arrière-plan : l'envoi a lieu quand l'app est ouverte
 * (au lancement, au retour du réseau, au retour dans l'app et toutes les 20 secondes).
 */
import { base, lireReglage } from "./base-locale";

export type ResultatSynchro = { envoyees: number; restantes: number; probleme?: string };

let enCours = false;

export async function synchroniser(): Promise<ResultatSynchro> {
  const restantes = () => base.notes.where("statut").equals("en_attente").count();
  if (enCours) return { envoyees: 0, restantes: await restantes() };
  if (!navigator.onLine) return { envoyees: 0, restantes: await restantes(), probleme: "hors ligne" };
  const code = await lireReglage("code");
  if (!code) return { envoyees: 0, restantes: await restantes(), probleme: "code d'accès manquant" };

  enCours = true;
  let envoyees = 0;
  let probleme: string | undefined;
  try {
    const enAttente = await base.notes.where("statut").equals("en_attente").sortBy("creeLe");
    for (const note of enAttente) {
      const formulaire = new FormData();
      formulaire.append("id", note.id);
      formulaire.append("texte", note.texte);
      formulaire.append("creeLe", note.creeLe);
      if (note.photo) formulaire.append("photo", note.photo, `${note.id}.jpg`);
      let reponse: Response;
      try {
        reponse = await fetch("/api/proto/notes", {
          method: "POST",
          headers: { "X-Code-Acces": code },
          body: formulaire,
        });
      } catch {
        probleme = "réseau interrompu pendant l'envoi";
        break;
      }
      if (reponse.status === 401) {
        probleme = "code d'accès refusé par le serveur";
        break;
      }
      if (!reponse.ok) {
        probleme = `le serveur a répondu ${reponse.status}`;
        break;
      }
      await base.notes.update(note.id, { statut: "envoyee", envoyeeLe: new Date().toISOString() });
      envoyees++;
    }
  } finally {
    enCours = false;
  }
  return probleme === undefined
    ? { envoyees, restantes: await restantes() }
    : { envoyees, restantes: await restantes(), probleme };
}
